export class ConfirmerRequestItem 
{
    requestItemId: number|undefined;
    montantAccorde: number;
    tauxAccorde: number;
    echeanceAccorde: number;
    commissionEngagementAccorde: number;
    typeTirage: String;
}